<template>
  <div v-if="userinfo" class="wrap">
    <userinfos :data="userinfo"></userinfos>
    <div class="section">
      <div v-for="item in list" :key="item" @click="jump(item.to)" class="row">
        {{ item.title }}
      </div>
    </div>
  </div>
</template>
<script>
import userinfos from './common/userinfos';
export default {
  name: '',
  components: {
    userinfos,
  },
  data() {
    return {
      list: [
        { title: '资产管理', to: '/capital/index' },
        { title: '官方客服' },
        { title: '帮助中心', to: '/help/index' },
      ],
    };
  },
  computed: {
    userinfo() {
      return this.$store.state.app.userinfos;
    },
  },
  methods: {
    jump(path) {
      if (!path) {
        wx.miniProgram.navigateTo({
          url: `/pages/service/index`,
        });
        return;
      }
      path && this.$router.push({ path: path });
    },
  },
};
</script>
<style lang="less" scoped>
.wrap {
  padding-top: 12px;
  .section {
    width: 93.6%;
    margin: 0 auto;
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
    padding: 0 20px;
    .row {
      line-height: 50px;
      height: 50px;
      // box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
      border-radius: 4px;
      background: url('https://img.zai-art.com/zaiart/saas/image/md/fe6b998bf9b73861cd4b50cedac3e3f7.png')
        no-repeat right;
      background-size: 18px 18px;
      border-bottom: 1px solid #f5f5f5;
      &:last-child {
        border: none;
      }
    }
  }
}
</style>
